/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.sv')
    .component('svsearch', {
      restrict: 'E',
      bindings: {
        sv: '<',
        svref: '<',
        parentsave: '&?',
        editinplace: '@?',
        ti: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showsv($item, $model, $label)"
                   uib-typeahead="sv as sv.text for sv in vm.getSvs($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        <i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>
        <div ng-show="noResults">
          <i class="fa fa-warning"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addSv()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addSv()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === 'true'">
          <sveditor sv="vm.sv"></sveditor>
        </div>
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Sv', 'SvHelper',
        function ($log, Sv, SvHelper) {
          let vm = this;
          vm.save = save;
          vm.showsv = showsv;

          vm.getSvs = getSvs;
          // vm.addSv = SvHelper.addSv;
          vm.addSv = addSv;
          vm.editSv = SvHelper.editSv;

          vm.$onInit = function () {
            vm.newsv = {};

            if (angular.isUndefined(vm.ti)) {
              vm.ti = '0';
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            } else {
              vm.tabi = 0;
            }
            vm.lastsv = angular.copy(vm.sv);
            vm.lastsvref = angular.copy(vm.svref);
          };

          function addSv() {
            $log.debug('debug - svsearch addSv called');
            SvHelper.addSv(function (sv) {
              $log.debug('debug: handle newly create sv');
              vm.sv = {};
              vm.sv.name = sv.name;
              vm.sv.short = sv.short;
              vm.sv._id = sv._id;
              vm.svref = sv._id;
              vm.asyncSelected = sv.short;
              vm.parentsave({sv: vm.sv, svref: vm.svref});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead sv search backend query
          function getSvs(val) {
            // return Svahead.$search({query: val}).$asPromise().then(function (response) {
            return Sv.$searchahead({query: val}).$asPromise().then(function (response) {
              return response.map(function (sv) {
                sv.text = sv.short;
                if (sv.old) {
                  sv.text = sv.short + '(' + sv.old + ')';
                }
                delete vm.error;
                return sv;
              });
            });
          }

          // typeahead sv search action
          function showsv($item, $model, $label) {
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            vm.sv = $model;
            vm.svref = $model._id;
            delete vm.asyncSelected;
            vm.editinplace = true;
            // $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
            if (vm.editinplace === 'true') {
              vm.sv = $model;
              vm.svref = $model._id;
              // $log.debug('debug - svsearch editinplace');
            } else {
              vm.sv = {};
              vm.sv.name = $model.name;
              vm.sv.short = $model.short;
              vm.sv.printlong = $model.printlong;
              vm.sv.old = $model.old;
              vm.sv.code = $model.code;
              vm.sv._id = $model._id;
              vm.svref = $model._id;
              vm.parentsave({sv: vm.sv, svref: vm.svref});
              // $log.debug('debug - svsearch do not editinplace', vm.parentsave);
            }
          }

          function save() {
            if (!angular.equals(vm.sv, vm.lastsv) || !angular.equals(vm.svref, vm.lastsvref)) {
              vm.lastsv = angular.copy(vm.sv);
              vm.lastsvref = angular.copy(vm.svref);
              vm.parentsave({sv: vm.sv, svref: vm.svref});
            }
          }

        }] // controller
    }); // component

// klammerfriedhof
}());
